<app-stages [stages]="stages" currentStage="Lokalizacja">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <br>
    <app-exposed-map-control #expMap [control]="form.geometry">
    </app-exposed-map-control>
    <app-road-controls-set [expMapDict]="expMap.dictEvent()" [form]="form">
    </app-road-controls-set>
    <br>
    <app-parcels-crud
      expMapDictPlotType="Drogowa"
      [expMapDict]="expMap.dictEvent()"
      formControlName="parcels">
    </app-parcels-crud>
  </form>
  <div class='application-actions'>
    <button
      [disabled]="pending()"
      (click)="onCancel()"
      type='button'
      class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      (click)="submitAndGoNext()"
      [disabled]="pending()"
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
